import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from '../../api/api';
import { METHODS, SERVICES } from '../../api/constants';
import { commonMoodlePayload } from '../../config';
import { MOODLE_BACKEND_ROUTES } from '../../config/apiRoutes';

export const fetchMeetingDetail = createAsyncThunk(
  'zoomSlice/fetchMeetingDetail',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        {
          ...param,
          ...commonMoodlePayload,
          wsfunction: MOODLE_BACKEND_ROUTES.GET_MEETING_DATA,
          wstoken: thunkApi.getState().auth.token
        }
      );
      return { data: response.data };
    } catch (e) {}
  }
);

export const zoomSlice = createSlice({
  name: 'zoomSlice',
  initialState: {
    loading: false,
    meetingData: {}
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchMeetingDetail.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchMeetingDetail.fulfilled, (state, action) => {
      state.loading = false;
      state.meetingData = action.payload.data;
    });
    builder.addCase(fetchMeetingDetail.rejected, (state) => {
      state.loading = false;
      state.meetingData = {};
    });
  }
});

export default zoomSlice.reducer;
